import { Aniale, DonationCourse, RewardCourse } from "interfaces/front/page/project";
import { AdminPreviewService } from "lib/service/client/AdminPreviewService";
import { FrontProjectService as ClientService } from "lib/service/client/FrontProjectService";
import { useAsyncMemo } from "lib/hooks/useAsyncMemo";
import * as Sentry from "@sentry/node";

export const useCourses = (
  service: ClientService,
  slug: string
): [RewardCourse[], DonationCourse | null | undefined, Aniale | null | undefined] => {
  const result = useAsyncMemo<[RewardCourse[], DonationCourse | null | undefined, Aniale | null | undefined]>(async () => {
    try {
      const result = await service.getCourses(slug);
      if (result.isSuccess()) {
        return [result.value.reward_courses, result.value.donation_course, result.value.aniale];
      } else {
        return [[], null, null];
      }
    } catch (e) {
      Sentry.captureException(e);
      return [[], null, null];
    }
  }, []);
  return result ?? [[], undefined, undefined];
};

export const useCoursesAsPreview = (
  service: AdminPreviewService | undefined,
  slug: string
): [RewardCourse[], DonationCourse | null | undefined, Aniale | null | undefined] => {
  const result = useAsyncMemo<[RewardCourse[], DonationCourse | null | undefined, Aniale | null | undefined]>(async () => {
    if (!service) return [[], undefined, undefined];
    try {
      const result = await service.getCourses(slug);
      if (result.isSuccess()) {
        return [result.value.reward_courses, result.value.donation_course, result.value.aniale];
      } else {
        return [[], null, null];
      }
    } catch (e) {
      Sentry.captureException(e);
      return [[], null, null];
    }
  }, [service]);
  return result ?? [[], undefined, undefined];
};
